import {
  faArrowLeft,
  faArrowUpRightFromSquare,
  faEye,
  faLock,
  faPencil,
  faTachometer,
  faTrashCan,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Scroll from "react-scroll";
import { useRecoilState } from "recoil";

import toast from "react-hot-toast";
import { getReportDetailAPI } from "../../API/Report";
import { deleteUserAPI, getUserDetailAPI } from "../../API/User";
import { userDetailState } from "../../AppState";
import DataDisplayRowSelect from "../../Components/Reusable/DataDisplayRowSelect";
import DataDisplayRowText from "../../Components/Reusable/DataDisplayRowText";
import PageLoadingContent from "../../Components/Reusable/PageLoadingContent";
import { USER_TRAIL_STATUS_OPTIONS } from "../../Constants/FieldOptions";

function OrgUserDetail() {
  const [user, setUser] = useRecoilState(userDetailState);

  const { id } = useParams();

  const [forceURL, setForceURL] = useState("");
  const [isFetching, setFetching] = useState(false);
  const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] =
    useState(false);
  const navigate = useNavigate();

  function onUserDetailSuccess(response) {
    setUser(response);
  }

  function onUserDetailError(apiErr) {
    toast.error(apiErr.message);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserDetailDone() {
    setFetching(false);
  }

  function onUserDeleteSuccess(response) {
    toast.success("User deleted Successfully");

    setForceURL("/org-users");
  }

  function onUserDeleteError(apiErr) {
    toast.error(apiErr.message);

    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserDeleteDone() {
    setFetching(false);
  }

  const onDeleteConfirmButtonClick = () => {
    deleteUserAPI(id, onUserDeleteSuccess, onUserDeleteError, onUserDeleteDone);
    setShowDeletionConfirmationModal(false);
  };

  const onReportClick = async (userID) => {
    try {
      setFetching(true);
      const response = await getReportDetailAPI(userID);

      if (response && response.data) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileURL;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("Report Created Successfully");
      } else {
        toast.error("Failed to generate report");
      }
    } catch (error) {
      toast.error("Error generating report");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0); // Start the page at the top of the page.

      setFetching(true);
      getUserDetailAPI(
        id,
        onUserDetailSuccess,
        onUserDetailError,
        onUserDetailDone
      );
    }

    return () => {
      mounted = false;
    };
  }, [id]);

  if (forceURL !== "") {
    return <Navigate to={forceURL} />;
  }

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/org-dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="">
                <Link to="/org-users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faUsers} />
                  &nbsp;Users
                </Link>
              </li>
              <li class="is-active">
                <Link to={`/org-user`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faEye} />
                  &nbsp;Detail
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/org-users`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Users
                </Link>
              </li>
            </ul>
          </nav>

          {/* Modal(s) */}
          <nav class="">
            <div
              class={`modal ${
                showDeletionConfirmationModal ? "is-active" : ""
              }`}
            >
              <div class="modal-background"></div>
              <div class="modal-card">
                <header class="modal-card-head">
                  <p class="modal-card-title">Are you sure?</p>
                  <button
                    class="delete"
                    aria-label="close"
                    onClick={(e, ses) =>
                      setShowDeletionConfirmationModal(false)
                    }
                  ></button>
                </header>
                <section class="modal-card-body">
                  You are about to delete this video section and all the data
                  inside of it. This action is cannot be undone. Are you sure
                  you would like to continue?
                </section>
                <footer class="modal-card-foot">
                  <button
                    class="button is-success"
                    onClick={onDeleteConfirmButtonClick}
                  >
                    Confirm
                  </button>
                  <button
                    class="button"
                    onClick={(e, ses) =>
                      setShowDeletionConfirmationModal(false)
                    }
                  >
                    Cancel
                  </button>
                </footer>
              </div>
            </div>
          </nav>

          {/* Page */}
          <nav class="box">
            {isFetching ? (
              <PageLoadingContent displayMessage={"Please wait"} />
            ) : (
              <>
                {/* Title + Options */}
                <div class="columns">
                  <div class="column">
                    <p class="title is-4">
                      <FontAwesomeIcon className="fas" icon={faUsers} />
                      &nbsp;User - {user.firstName} {user.lastName}
                    </p>
                  </div>
                  <div class="column has-text-right">
                    {/* to={`/org-user/${id}/change-password`} */}
                    <Link
                      class="button is-small is-link is-fullwidth-mobile"
                      type="button"
                    >
                      <FontAwesomeIcon className="mdi" icon={faLock} />
                      &nbsp;Change Password
                    </Link>
                    &nbsp;
                    {/* to={`/org-user/${id}/edit`} */}
                    <Link
                      class="button is-small is-warning is-fullwidth-mobile"
                      type="button"
                    >
                      <FontAwesomeIcon className="mdi" icon={faPencil} />
                      &nbsp;Edit User
                    </Link>
                    &nbsp;
                    {/* onClick={(e, ses) =>
                      setShowDeletionConfirmationModal(true)
                    } */}
                    <button
                      class="button is-small is-danger is-fullwidth-mobile"
                      type="button"
                    >
                      <FontAwesomeIcon className="mdi" icon={faTrashCan} />
                      &nbsp;Delete User
                    </button>
                  </div>
                </div>

                <div class="tabs is-medium">
                  <ul>
                    <li>
                      <Link class="is-active">
                        <strong>Detail</strong>
                      </Link>
                    </li>
                    <li>
                      <Link to={`/org-user/${id}/sessions`}>Sessions</Link>
                    </li>
                    <li>
                      <Link to={`/org-user/${id}/activities`}>Activities</Link>
                    </li>
                    <li>
                      <Link onClick={() => onReportClick(id)}>
                        Report&nbsp;
                        <FontAwesomeIcon
                          className="mdi"
                          icon={faArrowUpRightFromSquare}
                        />
                      </Link>
                    </li>
                  </ul>
                </div>

                <div class="columns">
                  <div class="column">
                    <p class="subtitle is-6">
                      <FontAwesomeIcon className="fas" icon={faEye} />
                      &nbsp;Detail
                    </p>

                    <DataDisplayRowText label="ID" value={user.id} />

                    <DataDisplayRowText
                      label="Birthday"
                      type="date_from_timestamp"
                      value={user.birthday}
                    />

                    <DataDisplayRowText
                      label="Clinic Code"
                      value={user.clinicCode}
                    />

                    <DataDisplayRowText
                      label="Stripe Checkout Intent"
                      value={user.stripeCheckoutIntent}
                    />

                    <DataDisplayRowText
                      label="Created"
                      type="date_from_timestamp"
                      value={user.created}
                    />

                    <DataDisplayRowText label="Email" value={user.email} />

                    <DataDisplayRowText
                      label="First Name"
                      value={user.firstName}
                      disabled={true}
                    />

                    <DataDisplayRowText
                      label="Last Name"
                      value={user.lastName}
                    />

                    <DataDisplayRowText
                      label="Injury Date"
                      type="date_from_timestamp"
                      value={user.injuryDate}
                    />

                    <DataDisplayRowText
                      label="Last Login Timestamp"
                      type="date_from_timestamp"
                      value={user.lastLoginTimestamp}
                    />

                    <DataDisplayRowText
                      label="Modified"
                      type="date_from_timestamp"
                      value={user.modified}
                    />

                    <DataDisplayRowSelect
                      label="Trial Status"
                      selectedValue={user.trialStatus}
                      options={USER_TRAIL_STATUS_OPTIONS}
                    />

                    <div class="columns">
                      <div class="column is-half">
                        <Link to="/users" class="button is-fullwidth-mobile">
                          <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                          &nbsp;Back to Users
                        </Link>
                      </div>
                      <div class="column is-half has-text-right">
                        <Link
                          to={`/user/${id}/edit`}
                          class="button is-warning is-fullwidth-mobile"
                        >
                          <FontAwesomeIcon className="fas" icon={faPencil} />
                          &nbsp;Edit
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default OrgUserDetail;
